import React, { useEffect, useState } from 'react';

export const Product = () => {
    return (
        <>
            <h3 style={{ marginBottom: '50px' }}>상품 정보</h3>
        </>
    );
};
